import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, EmptyState } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';
import { PatientPreviewTabs } from '../components';

function PatientSalesOrderListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        rootStore
    } = listViewStore;
    return (
        <ApplicationListLayout store={listViewStore}>
            <Content  emptyRenderer={renderEmpty()} >
            <PatientPreviewTabs route="master.app.main.patient.preview.orders" 
                queryParams={rootStore.routerStore.routerState.params}  />
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='ORDERS.LIST.EMPTY_STATE.TITLE' description='ORDERS.LIST.EMPTY_STATE.DESCRIPTION' />
}

PatientSalesOrderListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(PatientSalesOrderListTemplate);